var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 27.8663L22.5996 21.2666C26.2445 17.6218 26.2445 11.7122 22.5996 8.06732C18.9548 4.42243 13.0452 4.42243 9.40033 8.06732C5.75544 11.7122 5.75544 17.6218 9.40033 21.2666L16 27.8663ZM16 31.6375L7.51472 23.1523C2.82843 18.4659 2.82843 10.868 7.51472 6.18171C12.201 1.49542 19.7989 1.49542 24.4853 6.18171C29.1716 10.868 29.1716 18.4659 24.4853 23.1523L16 31.6375ZM16 17.3337C17.4728 17.3337 18.6667 16.1398 18.6667 14.667C18.6667 13.1942 17.4728 12.0003 16 12.0003C14.5272 12.0003 13.3333 13.1942 13.3333 14.667C13.3333 16.1398 14.5272 17.3337 16 17.3337ZM16 20.0003C13.0545 20.0003 10.6667 17.6125 10.6667 14.667C10.6667 11.7215 13.0545 9.33366 16 9.33366C18.9455 9.33366 21.3333 11.7215 21.3333 14.667C21.3333 17.6125 18.9455 20.0003 16 20.0003Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.3f8e9789ab68f2624db691f300bfed70.svg";
export { ForwardRef as ReactComponent };